// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"MPgwU","title":"_1Pk13","content":"_1WqnS"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewsBlock/NewsBlock.scss
 ** module id = 101
 ** module chunks = 0
 **/